export default "__VITE_ASSET__6bae7e43__"